var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 122.571,
    height: 157.143,
    viewBox: "0 0 122.571 157.143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container",
    filter: "url(#filter0_dd_0_34)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_34",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2857 77C28.2857 58.7746 43.0603 44 61.2857 44V44C79.5111 44 94.2857 58.7746 94.2857 77V77C94.2857 95.2254 79.5111 110 61.2857 110V110C43.0603 110 28.2857 95.2254 28.2857 77V77Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.2857 77C28.2857 58.7746 43.0603 44 61.2857 44V44C79.5111 44 94.2857 58.7746 94.2857 77V77C94.2857 95.2254 79.5111 110 61.2857 110V110C43.0603 110 28.2857 95.2254 28.2857 77V77Z",
    fill: "#F5F6F7",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2857 77M94.2857 77M94.2857 77M28.2857 77M61.2857 44M94.2857 77M61.2857 110M28.2857 77M61.2857 110V108.429C43.9282 108.429 29.8571 94.3575 29.8571 77H28.2857H26.7143C26.7143 96.0933 42.1924 111.571 61.2857 111.571V110ZM94.2857 77H92.7143C92.7143 94.3575 78.6432 108.429 61.2857 108.429V110V111.571C80.379 111.571 95.8571 96.0933 95.8571 77H94.2857ZM61.2857 44V45.5714C78.6432 45.5714 92.7143 59.6425 92.7143 77H94.2857H95.8571C95.8571 57.9067 80.379 42.4286 61.2857 42.4286V44ZM61.2857 44V42.4286C42.1924 42.4286 26.7143 57.9067 26.7143 77H28.2857H29.8571C29.8571 59.6425 43.9282 45.5714 61.2857 45.5714V44Z",
    fill: "#F08E00",
    mask: "url(#path-1-inside-1_0_34)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/pending"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M73.2857 77C73.2857 83.6274 67.9131 89 61.2857 89C54.6583 89 49.2857 83.6274 49.2857 77C49.2857 70.3726 54.6583 65 61.2857 65C67.9131 65 73.2857 70.3726 73.2857 77Z",
    strokeWidth: 2.4,
    stroke: "#F08E00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M61.2857 70.5V77L65.7857 79.8",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#F08E00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_0_34",
    x: 0,
    y: 0,
    width: 122.571,
    height: 157.143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.8571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1429
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.815686 0 0 0 0 0.847059 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_34"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -18.8571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5714
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.82 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_34",
    result: "effect2_dropShadow_0_34"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_34",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingBadge);
export default __webpack_public_path__ + "static/media/pending-badge.fb92713cbc05a851c7fc7032b66631d6.svg";
export { ForwardRef as ReactComponent };